import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import SweetAlert from 'sweetalert2/dist/sweetalert2';
import createElement from 'create-element';
import _escape from 'lodash/escape';

var _createElement = function _createElement(tag, className, content) {
  if (!content || !content.length) {
    return '';
  }

  return createElement(tag, {
    class: className
  }, _escape(content));
};

var alert = function alert(options) {
  var title = options.title,
      text = options.text,
      otherOptions = _objectWithoutProperties(options, ["title", "text"]);

  var classNames = ['insolus-alert'];

  if (options.type) {
    classNames.push("insolus-alert--".concat(options.type));
  }

  if (otherOptions.danger) {
    classNames.push("insolus-alert--danger");
    otherOptions.focusConfirm = false;
    otherOptions.focusCancel = true;
  }

  delete otherOptions.danger;

  var _options = Object.assign({}, otherOptions, {
    title: _createElement('span', 'insolus-alert__title', title),
    html: _createElement('p', 'insolus-alert__content', text),
    customClass: classNames.join(' '),
    confirmButtonClass: 'insolus-alert__button insolus-alert__button--confirm',
    cancelButtonClass: 'insolus-alert__button insolus-alert__button--cancel',
    buttonsStyling: false,
    reverseButtons: true
  });

  return SweetAlert.fire(_options);
};

export default alert;